<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-layout row wrap align-center class="mb-2 mt-3">
          <v-flex>
            <h3>
              <span class="pr-1" v-if="mode === 'full'"> {{ index }}</span>
              <span class="pr-1">{{ transI18n(finding.name) }}</span>
              <template v-if="finding.lesions && finding.lesions.length < 2">
                  <span class="font-weight-light"> {{ ro }}</span>
                  <span class="font-weight-light"> {{ earlyAdv }}</span>
              </template>
            </h3>
            <!--ro /sadf -->
          </v-flex>
          <v-flex>
            <slot name="findingAction" />
          </v-flex>
        </v-layout>
        <div class="lesion-info">
          <div align="center" class="pos-relative print-image">
            <img v-if="isColonReport && mode === 'full'" src="/img/colon-preview-img2.png" alt=""  />
            <img v-else-if="!isColonReport && mode === 'full'" src="/img/gastro-preview-img2.png" alt="" />
            <div
              v-if="locationNumbers.length > 0"
              class="highlight-point small"
              :class="isColonReport ? `highlight-colon-${locationNumber}` : `highlight-gastro-${locationNumber}`"
              v-for="(locationNumber, lIndex) in locationNumbers"
              :key="'highlight'+ lIndex"
            >
              <div class="highlight-inner-point">
                {{ index }}<span v-if="locationNumbers.length > 1">-{{ lIndex + 1 }}</span>
              </div>
            </div>
          </div>
          <ul class="pl-0 mb-3">
            <li
              class="list-style-none mb-2"
              v-for="(lesion, idx) in finding.lesions"
              :key="lesion.id"
            >
              <template
                v-if="
                  lesion.observation ||
                  lesion.intervention ||
                  lesion.ro ||
                  lesion.earlyAdv
                "
              >
                <h4
                  v-if="
                    (finding.takeNote === 'each' && finding.lesions.length > 1) ||
                    finding.takeNote !== 'each'
                  "
                >
                  {{
                    finding.takeNote === 'each'
                      ? `Lesion ${idx + 1}:`
                      : `${
                          finding.takeNote.slice(0, 1).toUpperCase() +
                          finding.takeNote.slice(1)
                        }:`
                  }}
                </h4>
              </template>

              <p class="mb-0">
                <template v-if="finding.lesions && finding.lesions.length > 1">
                  <span class="font-weight-light">{{
                    lesion.ro && `r/o:${lesion.ro}`
                  }}</span>
                  <span class="font-weight-light"> {{ lesion.earlyAdv }}</span>
                </template>
                <span v-if="lesion.observation">
                  {{ lesion.observation }}
                </span>
              </p>
              <p v-if="lesion.intervention">
                <span style="color: #2894ff">Intervention</span>:
                {{ lesion.intervention }}
              </p>
            </li>
          </ul>
        </div>
      </v-flex>
      <!-- 圖片 -->
      
    </v-layout>
    <div v-if="filterImages.length">
      <div
        class="ml-2 break-inside-page"
        style="padding: 5px"
      >
        <FindingItemImages 
          :finding="{
            images: filterImages
          }" 
          :imgArrange="imgArrange" 
          :showName="false"
        />
      </div>
    </div>

  </div>
</template>

<script>
import FindingItemImages from '@/components/preview/FindingItemImages.vue'
import FindingMixin from '@/mixins/findingMixins.js'
import { findMatchI18n } from '@/utils/findMatchI18n'
export default {
  name: 'FindingItemContent',
  mixins: [FindingMixin],
  components: {
    FindingItemImages
  },
  props: {
    locationNumbers: {
      type: Array,
      required: false,
      default: () => []
    },
    finding: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: 0
    },
    images: {
      type: Array,
      default: () => []
    },
    isColonReport: {
      type: Boolean,
      default: false
    },
    imgArrange: {
      type: Number,
      default: 3
    },
    mode: {
      type: String,
      default: 'full'
    }
  },
  computed: {
    filterImages() {
      return this.images.filter((img) => img.findingID === this.finding.id && img.status != 0)
    },
    ro() {
      if (!this.finding) return
      const text = this.finding.lesions.map((lesion) => lesion.ro).join('')
      return text && `r/o:${text}`
    },
    // 目前只看到在胃鏡出現
    earlyAdv() {
      if (!this.finding) return
      return this.finding.lesions.map((lesion) => lesion.earlyAdv).join('')
    },
  },
  methods: {
    getLandMarkInfoFromID(id) {
      return this.getLandmarkList.filter((item) => item.id == id).length
        ? this.getLandmarkList.filter((item) => item.id == id)[0].landmark
        : null
    },
    transI18n(text) {
      return findMatchI18n(text)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/components/reportImgArrange.scss';
.finding-item-images {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  gap: 10px;
  width: 100%;
  align-items: center;
}
.finding-item-images img{
  width: 240px;
}
.lesion-info{
  display: grid;
  grid-template-columns: 184px 1fr;
  // grid-template-columns: auto 1fr;
  gap: 10px;
  width:100%;
  .print-image{
    transform: scale(0.8);
  }
}
.highlight-point{
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 30px;
  display: flex;
  border-radius: 50%;
  background-color: rgba(13, 148, 136, 0.3);
  align-items: center;
  justify-content: center;
  > .highlight-inner-point{
    width: 22px !important;
    height: 22px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #ffffff;
    background-color: rgb(13, 148, 136);
    font-size:10px;
  }
  &.highlight-colon-1{
    top: 96px;
    left: 50px;
  }
  &.highlight-colon-2{
    top: 80px;
    left: 31px;
  }
  &.highlight-colon-3{
    top:121px;
    left:25px;
  }
  &.highlight-colon-4{
    top: 88px;
    left: 20px;
  }
  &.highlight-colon-5{
    top: 51px;
    left: 18px;
  }
  &.highlight-colon-6{
    top: 10px;
    left: 30px;
  }
  &.highlight-colon-7{
    top: 31px;
    left: 85px;
  }
  &.highlight-colon-8{
    top: 12px;
    left: 142px;
  }
  &.highlight-colon-9{
    top: 76px;
    left: 138px;
  }
  &.highlight-colon-10{
    top: 120px;
    left: 120px;
  }
  &.highlight-colon-11{
    top: 107px;
    left: 141px;
  }
  &.highlight-colon-12{
    top: 151px;
    left: 77px;
  }
  &.highlight-colon-13{
    top: 188px;
    left: 77px;
  }
  &.highlight-colon-14{
    top: 123px;
    left: -4px;
  }
  &.highlight-colon-15{
    top: 135px;
    left: -4px;
  }
  &.highlight-colon-16{
    top: 169px;
    left: 78px;
  }
  &.highlight-gastro-1, &.highlight-gastro-4{
    top: 61px;
    left: 85px;
  }
  &.highlight-gastro-2{
    top:27px;
    left:82px;
  }
  &.highlight-gastro-3{
    top:44px;
    left:82px;
  }
  &.highlight-gastro-5{
    top:82px;
    left:85px;
  }
  &.highlight-gastro-6{
    top:126px;
    left:80px;
  }
  &.highlight-gastro-7{
    top:119px;
    left:101px;
  }
  &.highlight-gastro-8, &.highlight-gastro-11{
    top:143px;
    left:92px;
  }
  &.highlight-gastro-9, &.highlight-gastro-10{
    top:138px;
    left:97px;
  }
  &.highlight-gastro-12{
    top:151px;
    left:85px;
  }
  &.highlight-gastro-13{
    top:141px;
    left:75px;
  }
  &.highlight-gastro-14{
    top:158px;
    left:80px;
  }
  &.highlight-gastro-15{
    top:143px;
    left:48px;
  }
  &.highlight-gastro-16, &.highlight-gastro-17, &.highlight-gastro-18{
    top:158px;
    left:45px;
  }
  &.highlight-gastro-19{
    top:108px;
    left:85px;
  }
}

</style>
